import { useEffect, useRef } from "react";
import musicController from "./music-controller";
import type { SoundId } from "./sounds";

// Play a sound once each time `on` turns true. For screens drawn from a clock
// (a pause's parts, a card that flips at a time) where no event marks the moment.
export function useSoundOn(on: boolean, id: SoundId): void {
  const was = useRef(false);
  useEffect(() => {
    if (on && !was.current) musicController.play(id);
    was.current = on;
  }, [on, id]);
}
